import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { CheckIcon } from 'lucide-react';
export function CSAddOns() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-542">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-543">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-544">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-545">
            ADD ONS TO MAXIMIZE YOUR GLOW
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-546"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-547">
          <AnimateOnScroll data-id="element-548">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-549">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-550">
                Exosomes
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-551">
                Enhance your ClearSilk treatment with exosomes for even better
                results. When applied immediately after your laser treatment,
                exosomes amplify healing and skin regeneration by delivering
                growth factors and proteins directly to your skin cells. This
                boosts cellular communication and collagen production, reducing
                inflammation and improving skin texture, tone, and overall
                health.
              </p>
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll delay={150} data-id="element-552">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-553">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-554">
                Our Proprietary "Power Trio"
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body mb-6" data-id="element-555">
                Optimize your ClearSilk treatment with Be CLINICAL's exclusive
                Power Trio blend. This proprietary mix includes stem cells,
                brightening agents, and peptides, all working together for
                glowing, beautiful results.
              </p>
              <ul className="space-y-4" data-id="element-556">
                <li className="flex items-start gap-3" data-id="element-557">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-558" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-559">
                    <strong className="text-white" data-id="element-560">Stem Cells</strong> –
                    Powerful growth factors that stimulate cells to behave
                    younger, promoting rejuvenation and vitality.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-561">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-562" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-563">
                    <strong className="text-white" data-id="element-564">Brightening Agents</strong> –
                    Glutathione and tranexamic acid even out your skin tone for
                    a luminous complexion.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-565">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-566" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-567">
                    <strong className="text-white" data-id="element-568">Peptides</strong> – Advanced
                    formula works on a cellular level to improve skin cell
                    function.
                  </span>
                </li>
              </ul>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}